/**
 * FeatureFlagRoute - Wrapper component for feature-flag protected routes
 *
 * Checks if the user has access to a feature and either renders the children
 * or redirects to dashboard with a message.
 */

import { Navigate } from 'react-router-dom'
import { useFeatureFlag } from '../hooks/useFeatureFlag'

const FeatureFlagRoute = ({ flagKey, children, fallbackPath = '/dashboard' }) => {
  const { enabled, loading } = useFeatureFlag(flagKey)

  // While loading, show nothing (parent Suspense will show fallback)
  if (loading) {
    return null
  }

  // If flag is not enabled, redirect to fallback path
  if (!enabled) {
    return <Navigate to={fallbackPath} replace />
  }

  // Feature is enabled, render children
  return children
}

export default FeatureFlagRoute
